import {Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientVendorsService extends BaseApiService {
  getVendors(client_id: string) {
    return this.get<Array<{ vendor: { key: string; name: string }, type: 'live' | 'test' }>>(`clients/${client_id}/credentials`).pipe(
      map(response => response.filter(item => item?.vendor).map(item => ({key: item.vendor.key, name: item.vendor.name, type: item.type})))
    );
  }

  saveVendorCredentials(client_id: string, data: any) {
    return this.post(`clients/${client_id}/credentials`, data);
  }

  deleteVendorCredentials(client_id: string, vendorKey: string, type: string) {
    return this.delete(`clients/${client_id}/credentials/${vendorKey}/${type}`);
  }
}
